import { useHistory, useLocation } from 'react-router-dom';
import { TabButtons, TabHealthera } from '../../healtheraComponents';

const routesMapper = {
  '/campaigns': 0,
};

const getActiveTab = (url) => {
  return routesMapper[url] || 0;
};

function CampaignTabs() {
  const location = useLocation();
  const history = useHistory();

  function handleTabChange(_, tabIndex) {
    if (routesMapper[location.pathname] === tabIndex) return;
    if (tabIndex === 0) return history.push('/campaigns');
    history.push('/');
  }

  return (
    <TabButtons
      height={`64px`}
      value={getActiveTab(location.pathname)}
      onChange={handleTabChange}>
      <TabHealthera label='Push Notifications' />
    </TabButtons>
  );
}

export default CampaignTabs;
